import React from "react";

export default function Home() {
  return (
    <div className="card">
      <h1>Cloudflare Pages + Vite 试验运行</h1>
      <p className="muted">
        这个页面用于验证：前端能在 Cloudflare Pages 跑起来，并且通过同源的 <code>/v1/*</code> 访问后端（或 mock）。
      </p>

      <ul>
        <li>
          <b>同源 API</b>：前端只请求相对路径 <code>/v1/...</code>，线上由 Pages Functions 代理到 <code>API_ORIGIN</code>
        </li>
        <li>
          <b>Mock 模式</b>：如果没有配置 <code>API_ORIGIN</code> 或者 <code>MOCK_API=1</code>，Functions 会直接返回 mock 数据
        </li>
        <li>
          <b>Turnstile</b>：线索提交页会带 <code>turnstileToken</code>（SiteKey 从 <code>VITE_TURNSTILE_SITEKEY</code> 读取）
        </li>
      </ul>

      <div className="card">
        <h3>当前构建环境</h3>
        <pre>{JSON.stringify({
          mode: import.meta.env.MODE,
          prod: import.meta.env.PROD,
          CF_PAGES: (import.meta as any).env?.CF_PAGES,
          CF_PAGES_BRANCH: (import.meta as any).env?.CF_PAGES_BRANCH,
        }, null, 2)}</pre>
        <p className="muted">
          注：Cloudflare Pages 会注入一些系统环境变量（例如 CF_PAGES / CF_PAGES_BRANCH），可用于区分预览/生产。
        </p>
      </div>
    </div>
  );
}
